import { ONLY_GRID,LION_BTC,HOLLAEX_PC_YOUTUBE,HARD_SIDE_SHOT_BLUE_BEAM, TEST_VIDEO ,SIDE_VIEW,OTC_BROKER_ARCADE,NEXT_STEP_WEB_3,HOLLAX_MAN_LOOKING_DOWN,BOX_WITH_FLOPPY,FRONT_SHOT_FLOPPY,DARK_GRID_COMPUTER ,ZIG_ZAG_LINES,HOLLAEX_MAN_LEFT,SMALL_HOVERING_MAN,LARGE_HOVERING_MAN} from '../../config/media';

export const backGround = [
        {
          video: ONLY_GRID,
          title: 'Streamlined crypto exchange hosting' ,
          desc: 'Streamline your crypto business with over 30% in savings for yearly exchange cloud plans.' ,
          btnTitle:'Cloud plans', 
          link: 'https://www.hollaex.com/pricing',
          posStyle:'bg-center',
          duration:'',
          animationType:'fadeIn 3s',
          animationDelay:0
         },
          {
          video: LION_BTC,
          title: 'Step up-to-date with HollaEx events and crypto news' ,
          desc: 'Stay in the crypto loop by following us on Twitter. Get information on coming upgrades and changes.' ,
          btnTitle:'HollaEx Twitter', 
          link: 'https://twitter.com/hollaex',
          posStyle:'bg-bottom-center',
          duration:'',
          animationType:'keyName-long 2s ease-out forwards',
          animationDelay:0
         },
        {
          video: HOLLAEX_PC_YOUTUBE,
          title: 'Crypto white label YouTube videos' ,
          desc: 'White-label crypto videos and educational materials on YouTube. Click below to learn more.' ,
          btnTitle:'HollaEx YouTube', 
          link: 'https://www.youtube.com/c/HollaEx',
          posStyle:'bg-center',
          duration:'',
          animationType:'mymove-right 1.5s',
          animationDelay:500
         },
        {
          video: HARD_SIDE_SHOT_BLUE_BEAM,
          title: 'Launching an exchange best practices' ,
          desc: 'Learn more about launching your own exchange and crypto business best practices.' ,
          btnTitle:'Launching an exchange', 
          link: 'https://docsend.com/view/s4bnx3wv4x9geqac',
          posStyle:'bg-center-left',
          duration:'',
          animationType:'mymove-left 1.5s',
          animationDelay:500
         },
        {
          video: HOLLAEX_MAN_LEFT, 	
          title: 'Unleash the power of crypto' ,
          desc: 'Get more power on your DIY crypto platform with the DIY exchange Boost plan.' ,
          btnTitle:'Boost Doc', 
          link: 'https://docsend.com/view/486k86i2fi59ymq5',
          posStyle:'bg-center-right unleash-content',
          duration:'',
          animationType:'fadeIn 3s',
          animationDelay:1000
         },
        {
          video: SMALL_HOVERING_MAN, 	
          title: 'Crypto cloud exchange platform' ,
          desc: 'Reduce hosting and server management overhead with HollaEx cloud. Read the docs below to learn more.' ,
          btnTitle:'Cloud docs', 
          link: 'https://docsend.com/view/gty6xw5j4ssun7tc',
          posStyle:'bg-bottom-center',
          duration:'',
          animationType:'fadeIn 3s',
          animationDelay:500
         },
          {
            video: HOLLAX_MAN_LOOKING_DOWN,
            title: 'Join the exchange builder community on Discord' ,
            desc: 'Get behind the scenes, learn from other exchange engineers, know when coins have been listed and more on Discord.' ,
            btnTitle:'HollaEx Discord', 
            link: 'https://discord.gg/ZN45kTdFd3',
            posStyle:'bg-top-center',
            duration:'',
            animationType:'fadeIn 4s',
            animationDelay:1500
          },
          {
            video: LARGE_HOVERING_MAN,
            title: 'HollaEx Documentation' ,
            desc: 'Looking to start your crypto platform? Learn more in the docs below.' ,
            btnTitle:'HollaEx Documentation', 
            link: 'https://docs.hollaex.com/',
            posStyle:'bg-center-right',
            duration:'',
            animationType:'mymove-right 2s',
            animationDelay:1000
           },
           {
            video: NEXT_STEP_WEB_3,
            title: 'List coins and create markets' ,
            desc: 'Start your Web3 business today with your own digitial assets and markets' ,
            btnTitle:'Coin & Market Listing', 
            link: 'https://www.hollaex.com/coin-and-market-listing',
            posStyle:'bg-center',
            duration:'',
            animationType:'fadeIn 3s',
            animationDelay:500
           },
           {
            video: OTC_BROKER_ARCADE,
            title: 'Set your own coin and token prices' ,
            desc: 'Set your own prices for both buy and sell with the HollaEx OTC broker system.' ,
            btnTitle:'OTC Broker', 
            link: 'https://docs.hollaex.com/how-tos/otc-broker',
            posStyle:'bg-center',
            duration:'',
            animationType:'fadeIn 1.5s',
            animationDelay:0
           },
           {
            video: TEST_VIDEO,
            title: 'XHT Staking & rewards program' ,
            desc: 'Stake & earn XHT through HollaEx Pro exchange. Click below to learn more.' ,
            btnTitle:'Stake XHT', 
            link: 'https://www.hollaex.com/hollaex-token-staking',
            posStyle:'bg-bottom-right-image',
            duration:'',
            animationType:' mymove-top 3s',
            animationDelay:1500
           },
           {
            video: SIDE_VIEW,
            title: 'Crypto exchange plugins apps' ,
            desc: "Add extra functionality to your exchange or build your own apps with HollaEx's plugin apps system." ,
            btnTitle:'Plugin Apps', 
            link: 'https://docs.hollaex.com/how-tos/develop-plugins',
            posStyle:'bg-center-left',
            duration:'',
            animationType:'mymove-left 2s',
            animationDelay:1000
           },
           {
            video: BOX_WITH_FLOPPY,
            title: 'Crypto white label insider info' ,
            desc: "Get the most cutting-edge information on the crypto industry and white-label solutions at HollaEx." ,
            btnTitle:'HollaEx Blogs', 
            link: 'https://www.hollaex.com/blog',
            posStyle:'bg-bottom-center',
            duration:'',
            animationType:'fadeIn 3s',
            animationDelay:1200
           },
           {
            video: FRONT_SHOT_FLOPPY,
            title: 'Open exchange discussions' ,
            desc: "Join the open-source crypto community and learn from other exchange builders." ,
            btnTitle:'HollaEx Forums', 
            link: 'https://forum.hollaex.com/',
            posStyle:'bg-center-right',
            duration:'',
            animationType:'keyName 1s ease-out forwards',
            animationDelay:0
           },
           {
            video: DARK_GRID_COMPUTER,
            title: 'HollaEx on AWS and DigitalOcean' ,
            desc: "DIY exchange self-hosting made easy with preinstalled HollaEx systems on AWS or DigitalOcean." ,
            btnTitle:'Amazon AWS', 
            link: 'https://marketplace.digitalocean.com/apps/hollaex-kit',
            posStyle:'bg-center',
            duration:'',
            animationType:'mymove-bottom 2s',
            animationDelay:1000
           },
           {
            video: ZIG_ZAG_LINES,
            title: 'HollaEx white label resources' ,
            desc: "Search and you shall find! Visit HollaEx's resource page to find docs, videos and answers." ,
            btnTitle:'Resources', 
            link: 'https://www.hollaex.com/resources',
            posStyle:'bg-bottom-center',
            duration:'',
            animationType:'mymove-bottom 2s',
            animationDelay:1000
           },
]